export enum RouteKeys {
  Home = '/',
  Dashboard = '/dashboard',
  Projects = '/projects',
  Plans = '/plans',
  Resources = '/resources',
  Reports = '/reports',
  HourLogs = '/hour-logs',
  ResourceHourLogs = '/resource-hour-logs',
  AdminUsers = '/admin-users',
  Teams = '/teams',
  ApiRoles = '/api-roles',
  ApiPermissions = '/api-permissions',
  AccessLogs = '/access-logs',
  Auth = '/auth',
  NotFound = '/page-not-found',
  Budgets = '/budgets',
  ResourceHourlyRates = '/resource-hourly-rates',
  Skills = '/skills',
  BudgetTypes = '/budget-types',
  PlanVsActual = '/plan-vs-actual',
  Leaves = '/leaves',
}
